import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import AudioDescribedIcon from './AudioDescribedIcon';
import './V2AudioDescribedToggle.css';

export default function V2AudioDescribedToggle({ checked, onPreferenceChange }) {
  const label = checked
    ? 'Switch to standard video'
    : 'Switch to audio described video';

  return (
    <div className="V2AudioDescribedToggle">
      <Tooltip title={label} placement="top">
        <IconButton
          className={
            'V2AudioDescribedToggle-button' + (checked ? ' is-active' : '')
          }
          aria-label={label}
          aria-pressed={checked}
          onClick={() => onPreferenceChange(!checked)}
          data-testid="ad-toggle-button">
          <AudioDescribedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </div>
  );
}
